import MainWorkSpace from "../../components/workspace/main-workspace";

function WorkSpace() {
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
        <MainWorkSpace/>
    </div>
  );
}

export default WorkSpace;


